var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 46,
    viewBox: "0 0 62 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5005,
    cy: 25.5,
    r: 20.5,
    fill: "black",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6594 35.3637C33.6049 35.3637 35.1821 33.7865 35.1821 31.841C35.1821 29.8954 33.6049 28.3182 31.6594 28.3182C29.7138 28.3182 28.1367 29.8954 28.1367 31.841C28.1367 33.7865 29.7138 35.3637 31.6594 35.3637Z",
    stroke: "black",
    strokeWidth: 2.81818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3416 35.3637C15.2872 35.3637 16.8643 33.7865 16.8643 31.841C16.8643 29.8954 15.2872 28.3182 13.3416 28.3182C11.3961 28.3182 9.81885 29.8954 9.81885 31.841C9.81885 33.7865 11.3961 35.3637 13.3416 35.3637Z",
    stroke: "black",
    strokeWidth: 2.81818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1367 17.0454H33.773L38.0003 21.2727V28.3181H28.1367V17.0454Z",
    stroke: "black",
    strokeWidth: 2.81818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1369 10H7.00049V28.3182H28.1369V10Z",
    stroke: "black",
    strokeWidth: 2.81818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup20);
export default __webpack_public_path__ + "static/media/Group 20.8b4dad34b8cdd93ccf7dddd3cc15353c.svg";
export { ForwardRef as ReactComponent };